<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <ul v-loading.capture="loading" class="allList" :style="loading == true ? 'position: absolute;margin-top: 50px;width: calc(100vw - 168px);' : newLoad == true ? 'position: absolute;margin-top: 50px;width: calc(100vw - 168px);' : 'margin-top: 50px;'" element-loading-text="数据努力加载中，请稍等...">
        <li v-for="(v,n) in orderList" :key="n">
          <div class="p">
            <div v-if="v.refundStatus != 1 && v.refundStatus != 2">
              <p v-if="v.orderType != 5 && v.orderStatus != 4" :class="v.partPayType == 1 ? 'color three' : v.orderStatus == 1 ? 'color one' : v.orderStatus == 2 ? 'color two' : 'color three'">{{ v.partPayType == 1 ? '部分支付' : v.orderStatus == 1 ? '待结算' : v.orderStatus == 2 ? '已结算' : '部分支付' }}</p>
              <p v-else-if="v.orderStatus == 4" class="color four">{{ v.refundStatus==3&& v.bookStatus !== -4 ? '部分退款' : '全部退款' }}</p>
              <p v-else :class="v.partPayType==3 ? 'color one' : v.partPayType==5 ? 'color two' : 'color one'">{{ v.partPayType==3 ? '使用中' : v.partPayType == 5 ? getRoomType==1?'已退房':'已退位' : '使用中' }}</p>
            </div>
            <div v-else>
              <p class="color five">{{ v.refundStatus==1 ? '退款中' : '退款失败' }}</p>
            </div>
            <p class="orderCode">订单号：{{ v.orderCode || '--' }}</p>
            <p class="orderStatus">{{ Lib.getOrderTypeName(v.orderType) }}</p>
            <p class="orderSource">
              <span>订单来源：</span>
              <samp>{{ v.buySource == 0 ? '电脑端' : v.buySource == 1 ? '粉丝端' : v.buySource == 2 ? '店员APP' : 'Smartbox' }}</samp>
            </p>
          </div>
          <div class="orderFlex">
            <div class="info customerInfo">
              <p>顾客信息</p>
              <h5><img v-if="v.memberType != 0" :src="returnImg(v.memberType)" />{{ v.customerName || '新增顾客' }}</h5>
              <h5>{{ v.phone ? Lib.starPhone(v.phone) : '--' }}</h5>
            </div>
            <div v-if="v.orderType != 6" class="info orderTime">
              <p>{{ v.orderType != 5 ?'开单时间' :'使用时间' }}</p>
              <h5>{{ v.createTime || '--' }}</h5>
              <p>{{ v.orderType != 5 ?'结算时间' :'离店时间' }}</p>
              <h5>{{ v.orderType != 5? v.payTime:v.endTime|| '--' }}</h5>
            </div>
            <div v-else class="info orderTime">
              <p>下单时间</p>
              <h5>{{ v.createTime || '--' }}</h5>
              <p>预约时间段</p>
              <h5>{{ v.timeDate || '--' }}</h5>
            </div>
            <div class="info orderSurvey">
              <p v-if="v.orderContent">{{ v.orderType != 5 ?'订单概况' :'房间名称' }}</p>
              <el-tooltip v-if="v.orderContent" effect="light" placement="top" :disabled="tooltipStatus">
                <div slot="content">
                  <h3 style="color: #999;">
                    <span v-for="(a,m) in v.orderContent" :key="m">{{ a.name }}{{ v.orderType == 5 ? '(' : ' *' }}{{ a.count }}{{ v.orderType == 5 ? ')' : '' }}{{ v.orderContent.length == (m+1) ? '' : ',' }}</span>
                    <span v-show="v.orderContent.length == 0">--</span>
                  </h3>
                </div>
                <h3 @mouseover="tooltipStatus = Lib.textShow($event)">
                  <span v-for="(b,m) in v.orderContent" :key="m">{{ b.name }}{{ v.orderType == 5 ? '(' : ' *' }}{{ b.count }}{{ v.orderType == 5 ? ')' : '' }}{{ v.orderContent.length == (m+1) ? '' : ',' }}</span>
                  <span v-show="v.orderContent.length == 0">--</span>
                </h3>
              </el-tooltip>
              <p v-if="v.orderRoomContent">房间名称</p>
              <el-tooltip v-if="v.orderRoomContent" effect="light" placement="top" :disabled="tooltipStatus">
                <div slot="content">
                  <h3 style="color: #999;">
                    <span v-for="(a,m) in v.orderRoomContent" :key="m">{{ a.name }}{{ v.orderRoomContent.length == (m+1) ? '' : ',' }}</span>
                    <span v-show="v.orderRoomContent.length == 0">--</span>
                  </h3>
                </div>
                <h3 @mouseover="tooltipStatus = Lib.textShow($event)">
                  <span v-for="(b,m) in v.orderRoomContent" :key="m">{{ b.name }}{{ v.orderRoomContent.length == (m+1) ? '' : ',' }}</span>
                  <span v-show="v.orderRoomContent.length == 0">--</span>
                </h3>
              </el-tooltip>
              <!-- <h3 v-else>--</h3> -->
              <p>备注</p>
              <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                <div slot="content">
                  <h3 style="color: #999;">{{ v.remark || '--' }}</h3>
                </div>
                <h3 @mouseover="tooltipStatus = Lib.textShow($event)">{{ v.remark || '--' }}</h3>
              </el-tooltip>
            </div>
            <div v-if="v.orderType != 5" class="info orderTotal">
              <p>{{ v.orderType == 6 ?'订单定金' :'订单金额' }}</p>
              <h5>￥{{ (v.orderAmount*1).toFixed(2) }}</h5>
              <p v-if="v.partPayType == 1 && v.balance">未支付</p>
              <h2 v-if="v.partPayType == 1 && v.balance">￥{{ v.balance || '0.00' }}</h2>
            </div>
            <div v-else class="info orderTotal">
              <p>{{ v.partPayType == 5 ? '使用时长' : '预计时长' }}</p>
              <h5>{{ v.dateTime || '' }}</h5>
            </div>
            <div class="info serviceStaff">
              <p>{{ v.orderType == 5 ? '操作' : '服务' }}员工</p>
              <h6>
                <!-- <span v-show="v.technicianName">{{v.isGuest == 1 ?'点客':'非点客'}}-</span> -->
                {{ v.technicianName || '--' }}
              </h6>
            </div>
            <div v-if="v.orderType != 6" class="info btnList">
              <yz-btn type="primary" @click="seeOrder(v)">详情</yz-btn>
              <yz-btn v-if="v.partPayType == 1" type="primary" @click="paymentRecords(v.orderCode,v.orderType)">付款记录</yz-btn>
              <yz-btn v-if="v.partPayType == 1 && v.balance" type="primary" @click="settlementOrder(v.orderId,'partPay',v.orderType,v.phone)">还款</yz-btn>
              <yz-btn v-if="v.orderStatus == 1 && v.orderType != 5" type="primary" @click="editOrder(v.orderId)">修改</yz-btn>
              <yz-btn v-if="v.orderStatus == 1 && v.orderType != 5" type="primary" @click="settlementOrder(v.orderId)">结算</yz-btn>
              <yz-btn v-if="v.orderStatus == 1 && v.orderType != 5 && v.orderType != 7 && v.orderType != 8 && v.orderType != 9" type="delete" @click="delOrder(v.orderId,v.orderType,$event)">删除</yz-btn>
              <yz-btn v-if="v.orderStatus == 1 && v.orderType == 5" type="primary" @click="onCheckOutOrder(v)">{{ getRoomType==1?'退房':'退位' }}</yz-btn>
            </div>
            <div v-else class="info btnList">
              <yz-btn type="primary" @click="seeOrder(v)">详情</yz-btn>
              <yz-btn v-show="v.bookStatus== 4" type="primary" @click="isConfirm(v.orderId,1)">确认</yz-btn>
              <yz-btn v-show="v.bookStatus== 4" type="primary" @click="isConfirm(v.orderId,0)">拒绝</yz-btn>
              <yz-btn v-show="v.bookStatus== 0 || v.bookStatus== 3" type="primary" @click="openBill(v.orderId)">开单</yz-btn>
              <yz-btn v-show="v.bookStatus== 0 || v.bookStatus== 3" type="primary" @click="cancelBespeak(v.orderId,v.buySource,2)">取消</yz-btn>
              <yz-btn v-show="v.bookStatus== 2" type="primary" @click="editOrder(v.orderId)">修改</yz-btn>
              <yz-btn v-show="v.bookStatus== 2" type="primary" @click="settlementOrder(v.orderId)">结算</yz-btn>
            </div>
          </div>
        </li>
      </ul>

      <div v-if="orderList.length > 0" class="allFooter">
        <el-pagination background :current-page.sync="pageNum" :page-sizes="[5, 10, 15, 20, 30, 40,50]" :page-size="pageSizeVal" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
        <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
      </div>

      <div v-if="orderList.length == 0 && loading == false" class="noneData">暂无数据</div>

      <gt-delDig @delData="getDelData"></gt-delDig>

      <yzPayDeatils @payRecord="getPayRecordData" />
      <!--预约取消 /拒绝弹窗-->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
        <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
        <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
        <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
        <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getAllOrderListPageBean, getCheckOutOrder, getSureOrFalse, getBookFailures,
} from '../../api';
import crown from '../../../../assets/images/crown.png';
import plante from '../../../../assets/images/plante.png';
import { getBookCancelMsg } from '../../../publicVue/thirdPage/api';
import { getPayCodeList } from '../../../stage/template/beautyCard/api';
import yzPayDeatils from '../../../stage/template/orderDeatilsData/template/payDetails';

export default {
  components: {
    yzPayDeatils
  },
  props: {
    newSearchVal: {
      type: String,
      default: String
    },
    newRemarkVal: {
      type: String,
      default: String
    },
    dateVal: {
      type: Array,
      default: Array
    },
    customerTypeVal: {
      type: String,
      default: String
    },
    serviceStaffVal: {
      type: Array,
      default: Array
    },
    openStaffVal: {
      type: Array,
      default: Array
    },
    settlementStaffVal: {
      type: Array,
      default: Array
    },
    orderStatusVal: {
      type: String,
      default: String
    },
    orderTypeVal: {
      type: String,
      default: String
    },
    settlementDateVal: {
      type: Array,
      default: Array
    },
    resetScreenStatus: {
      type: Number,
      default: Number
    },
    orderSourceVal: {
      type: Number,
      default: Number
    },
    useQyVal: {
      type: String,
      default: String
    },
    useDiscountVal: {
      type: String,
      default: String
    },
    buckleVal: {
      type: Number,
      default: Number
    },
    roomVal: {
      type: Array,
      default: Array
    },
    handCardVal: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      orderList: [],
      pageNum: 1,
      rowCount: 0,
      pageSizeVal: 5,
      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
      deleteStatus: false,

      useDetailsDialog: false,
      chooseOrderCode: '',
      useDetailsList: [],
      form: {
        useDetailsDialog: false,
        orderType: '',
        code: ''
      },
      chooseId: '', // 取消预约的ID
      dialogVisible: false, // 取消预约弹出窗口
      loading: true, // 订单列表预加载参数
      newLoad: true,
      cancelStatus: 1, // 取消预约退不退定金
      diaStatus: 3, // 弹出窗口文案提示状态
      IsAq: '',
      tooltipStatus: false,
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      offsetTop: 0,
    };
  },
  watch: {
    'delForm.status': function (val) {
      if (val == true) {
        this.pageNum = 1;
        this.deleteStatus = true;
        this.$emit('getDelStatus', this.deleteStatus);
        this.getListData('定位');
      }
    },
    newSearchVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    newRemarkVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    dateVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    customerTypeVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    serviceStaffVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    openStaffVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    settlementStaffVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    orderStatusVal(val) {
      if (this.resetScreenStatus == 2) return;
      window.sessionStorage.orderListStatus = val || '';
      this.pageNum = 1;
      this.getListData();
    },
    orderTypeVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    settlementDateVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    orderSourceVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    useQyVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    useDiscountVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    buckleVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    roomVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    },
    handCardVal() {
      if (this.resetScreenStatus == 2) return;
      this.pageNum = 1;
      this.getListData();
    }
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    this.getPayList();
    this.getListData();
    this.$emit('getDelStatus', this.deleteStatus);
  },
  methods: {
    // 获取支付方式列表
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          res.data.forEach((a) => {
            if (a.payType == 40) {
              window.sessionStorage.IsAq = a.isOpen;
            }
          });
        } else {
          console.log(res);
        }
      });
    },
    // 赋值组件数据----付款记录
    getPayRecordData(list) {
      this.form = list;
    },
    // 付款记录--弹窗
    paymentRecords(code, type) {
      this.form.useDetailsDialog = true;
      this.form.code = code;
      this.form.orderType = type == 3 ? 1 : 0;
    },
    // 获取订单列表数据
    getListData(val) {
      let technicianIds = '';
      this.serviceStaffVal.forEach((a) => {
        technicianIds += `${a},`;
      });
      let openTechnicianIds = '';
      this.openStaffVal.forEach((a) => {
        openTechnicianIds += `${a},`;
      });
      let closeTechnicianIds = '';
      this.settlementStaffVal.forEach((a) => {
        closeTechnicianIds += `${a},`;
      });
      let roomIds = '';
      this.roomVal.forEach((a) => {
        roomIds += `${a},`;
      });
      this.loading = true;
      this.newLoad = true;
      this.$emit('loadStatus', this.loading);
      const data = {
        pageSize: this.pageSizeVal,
        pageNum: this.pageNum,
        mainId: window.sessionStorage.mainId,
        keyWord: this.newSearchVal,
        remark: this.newRemarkVal,
        openStartDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[0] : '' : '',
        openEndDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[1] : '' : '',
        closeStartDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[0] : '' : '',
        closeEndDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[1] : '' : '',
        orderStatus: window.sessionStorage.orderListStatus || this.orderStatusVal || '',
        orderType: this.orderTypeVal || '',
        memberType: this.customerTypeVal || '',
        technicianIds,
        openTechnicianIds,
        closeTechnicianIds,
        buySource: this.orderSourceVal, // 来源
        rightsType: this.useQyVal, // 使用权益
        discountsType: this.useDiscountVal, // 使用优惠
        deductType: this.buckleVal, // 划扣类型
        handSearch: this.handCardVal, // 手牌查询
        roomIds, // 房间ID
      };
      getAllOrderListPageBean(data).then((res) => {
        if (res.code === 0) {
          this.orderList = res.data.records;
          this.rowCount = res.data.total;
          this.loading = false;
          setTimeout(() => {
            this.newLoad = false;
          }, 500);
          if (val === '定位') {
            $('.right-content').animate({
              scrollTop: this.offsetTop ? (this.offsetTop * 1 - 800) : 0
            }, 800);
          }
          this.$emit('loadStatus', this.loading);
        } else {
          // console.log(res)
        }
      });
    },
    // 获取返回图片（1为套餐，2为样子）
    returnImg(type) {
      if (type == 1) {
        return crown;
      }
      return plante;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSizeVal = val;
      this.pageNum = 1;
      this.Lib.backTop();
      this.getListData();
    },
    // 分页
    handleCurrentChange() {
      this.Lib.backTop();
      this.getListData();
    },

    // 修改订单
    editOrder(id) {
      if (this.Lib.checkPower('beauty-2-xgdd') == false) return;
      window.sessionStorage.editOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling',
      });
    },
    // 结算订单
    settlementOrder(id, val, type, phone) {
      if (type == 3) {
        if (this.Lib.checkPower('beauty-2-jsdd') == false) return;
        window.sessionStorage.rechargePhone = phone;
        this.$router.push({
          name: 'stage-recharge',
          params: {
            partPay: 1,
            id,
            newTitle: '还款'
          }
        });
      } else {
        if (this.Lib.checkPower('beauty-2-jsdd') == false) return;
        window.sessionStorage.settlementOrderId = id;
        this.$router.push({
          name: 'stage-orderSettlement',
          params: {
            partPay: val ? 1 : 0,
            newTitle: val ? '还款' : '订单结算'
          }
        });
      }
    },
    // 删除订单
    delOrder(id, type, e) {
      if (this.Lib.checkPower('beauty-2-scdd') == false) return;
      this.offsetTop = e.target.offsetTop;
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = type == 2 ? 'deleteQuickOrder' : 'deleteOrder';
      this.delForm.text1 = '确认要删除这条订单吗？';
      this.delForm.text2 = '删除后订单数据将无法恢复';
      this.delForm.status = false;
    },
    // 调用公共组件--赋值
    getDelData(list) {
      this.delForm = list;
    },
    // 从订单点击退房
    onCheckOutOrder(v) {
      if (this.Lib.checkPower('beauty-2-twtf') == false) return;
      // 5.10
      this.$confirm(this.getRoomType == 1 ? '确定退房?' : '确定退位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getCheckOutOrder({ orderCode: v.orderCode, mainId: window.sessionStorage.mainId }).then((res) => {
          if (res.code == 0) {
            this.getListData();
            this.$emit('getOrderCount');
            this.$message({ message: this.getRoomType == 1 ? '退房成功' : '退位成功', type: 'success' });
          } else {
            console.log(res);
          }
        });
      });
    },
    // // 子父组件赋值
    // newGetListData() {
    //   this.getListData();
    //   this.$emit('getDelStatus', true);
    // },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm(id, status) {
      if (this.Lib.checkPower('beauty-2-yyddqr') == false) return;
      this.diaStatus = status;
      this.chooseId = id;
      if (this.diaStatus == 0) {
        this.dialogVisible = true;
      } else {
        this.comfirmCancelBespeak();
      }
    },
    // 预约开单
    openBill(id) {
      if (this.Lib.checkPower('beauty-2-yyddkd') == false) return;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 取消预约
    cancelBespeak(id, source, num) {
      if (this.Lib.checkPower('beauty-2-yyddqx') == false) return;
      this.diaStatus = num;
      this.getMsg(id);
    },
    getMsg(id) {
      getBookCancelMsg({ id }).then((res) => {
        if (res.code == 0) {
          this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
          this.chooseId = id;
          this.dialogVisible = true;
        } else {
          console.log(res);
        }
      });
    },
    // 确定取消/拒绝预约
    comfirmCancelBespeak() {
      if (this.diaStatus == 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            this.dialogVisible = false;
            this.getListData();
            this.$emit('getOrderCount');
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        const data = {
          orderId: this.chooseId,
          type: this.diaStatus
        };
        getSureOrFalse(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: (this.diaStatus == 1 ? '确认成功' : '拒绝成功'), type: 'success' });
            this.dialogVisible = false;
            this.getListData();
          } else {
            this.$message(res.msg);
          }
        });
      }
    },

    // 6.7
    // 查看订单
    seeOrder(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },

  }
};
</script>

<style lang="less" scoped>
.allList {
  margin: 20px 0 48px 0;
  padding-right: 2px;
  li:last-child {
    margin-bottom: 48px;
  }
  li {
    width: 100%;
    border: 1px solid #dfe6ec;
    list-style-type: none;
    margin-bottom: 20px;
    height: auto;
    .p {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      background-color: #f5f5f5;
      border-bottom: 1px solid #dfe6ec;
      .color {
        height: 26px;
        line-height: 26px;
        text-align: center;
        padding: 0 9px;
        border-radius: 4px;
        font-size: 12px;
        margin: 6px 20px 6px 0;
        float: left;
      }
      .one {
        color: #f56c6c;
        border: solid 1px #fde2e2;
        background-color: #fef0f0;
      }
      .two {
        color: #75da98;
        border: solid 1px #def7e7;
        background-color: #eefff4;
      }
      .three {
        color: #efc160;
        border: solid 1px #fff2d7;
        background-color: #fffaef;
      }
      .four {
        color: #4ea5ff;
        border: solid 1px #dcedff;
        background-color: #eff7ff;
      }
      .five {
        color: #ef8026;
        border: solid 1px #fddec5;
        background-color: #fff6ee;
      }
      .orderCode {
        font-size: 14px;
        color: #333333;
        padding-right: 20px;
        float: left;
      }
      .orderStatus {
        font-size: 14px;
        color: #999999;
        padding-right: 20px;
        float: left;
      }
      .orderSource {
        float: right;
        font-size: 14px;
        span {
          color: #999;
        }
        samp {
          color: #333;
        }
      }
    }
    .orderFlex {
      display: flex;
      .info {
        padding: 14px 20px;
        flex: 1;
        border-right: 1px solid #dfe6ec;
        p {
          font-size: 14px;
          color: #999;
          height: auto;
          line-height: 26px;
        }
        h2 {
          height: auto;
          line-height: 26px;
          font-size: 14px;
          color: #ff4949;
        }
        h3 {
          height: 26px;
          line-height: 26px;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        h5 {
          height: auto;
          line-height: 26px;
          font-size: 14px;
          color: #333;
          img {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            float: left;
            margin: 3px 5px 3px 0;
          }
        }
        h6 {
          margin-top: 5px;
          height: 64px;
          line-height: 16px;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          word-break: break-all;
        }
      }
      .btnList {
        border-right: 0;
        margin: 6px 0;
        padding: 14px 15px 14px 20px;
        button {
          margin: 0 5px 10px 0;
        }
      }
    }
  }
}
.noneData {
  margin-top: 54px;
  height: 30px;
  line-height: 30px;
  padding: 30px 0;
  font-size: 14px;
  border-radius: 4px;
  color: #909399;
  text-align: center;
  border: 1px solid #e6ebf5;
}
</style>

<style>
.orderFlex .customerInfo {
  min-width: calc(13% - 40px);
  max-width: calc(13% - 40px);
}
.orderFlex .orderTime {
  min-width: calc(13% - 40px);
  max-width: calc(13% - 40px);
}
.orderFlex .orderSurvey {
  min-width: calc(30% - 40px);
  max-width: calc(30% - 40px);
}
.orderFlex .orderTotal {
  min-width: calc(13% - 40px);
  max-width: calc(13% - 40px);
}
.orderFlex .serviceStaff {
  min-width: calc(15% - 40px);
  max-width: calc(15% - 40px);
}
.orderFlex .btnList {
  min-width: calc(12% - 40px);
}
</style>
